import { render, staticRenderFns } from "./text-editor-full-extension-list.vue?vue&type=template&id=41da0a8a"
import script from "./text-editor-full-extension-list.vue?vue&type=script&lang=js"
export * from "./text-editor-full-extension-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports